import { render } from "./patient-register-step5.vue?vue&type=template&id=258f68e2"
import script from "./patient-register-step5.vue?vue&type=script&lang=js"
export * from "./patient-register-step5.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__